/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_N_AInputs */

const en_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const es_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const fr_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const de_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ja_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該当なし`)
};

const zh_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不适用 (N/A)`)
};

const ar_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير متوفر`)
};

const id_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const it_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ru_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Н/Д`)
};

const pt_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const ko_val_n_a = /** @type {(inputs: Val_N_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 없음`)
};

/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Val_N_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_n_a = /** @type {((inputs?: Val_N_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_N_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_n_a(inputs)
	if (locale === "es") return es_val_n_a(inputs)
	if (locale === "fr") return fr_val_n_a(inputs)
	if (locale === "de") return de_val_n_a(inputs)
	if (locale === "ja") return ja_val_n_a(inputs)
	if (locale === "zh") return zh_val_n_a(inputs)
	if (locale === "ar") return ar_val_n_a(inputs)
	if (locale === "id") return id_val_n_a(inputs)
	if (locale === "it") return it_val_n_a(inputs)
	if (locale === "ru") return ru_val_n_a(inputs)
	if (locale === "pt") return pt_val_n_a(inputs)
	return ko_val_n_a(inputs)
});